import React, { Suspense, lazy } from 'react';
import { SpinnerDotted } from 'spinners-react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import Outerlayout from '../layouts/outerLayout';
import Innerlayout from '../layouts/innerLayout';
import { getCookies } from '../hooks/useCookies';
import { clearAuthCookies, isTokenValid } from '../utils/authUtils';
import Settings from '../pages/settings/settings';
import ViewUsers from '../pages/users/viewUser';
import UserEdit from '../pages/users/editUser';
// import UserIndex from '../pages/users/index';
import UserCreate from '../pages/users/createUser';
// import Preferences from '../pages/settings/preferences';
import CreateRoles from '../pages/roles/createRoles';
import RolesIndex from '../pages/roles/index';
import EditRoles from '../pages/roles/editRoles';
// import SettingsApi from '../pages/settings/SettingsApiPage';
// import SettingsLayout from '../pages/settings/settingsLayout';
import PageNotFound from '../pages/404/pageNotFound';
import PermissionDenied from '../pages/permission/permission';
import ProfileLayout from '../pages/profile/profileLayout';

const Login = lazy(() => import('../pages/logIn/logIn'));
const UserIndex = lazy(() => import('../pages/users/index'));
const UserVerification = lazy(() => import('../pages/verify/userVerfication'));
const Register = lazy(() => import('../pages/register/register'));
const Forgetpassword = lazy(() => import('../pages/passwords/forgetPassword'));
const EmployeeIndex = lazy(() => import('../pages/employees/index'));
const EmployeeCreate = lazy(() => import('../pages/employees/create'));
const EmployeeEdit = lazy(() => import('../pages/employees/edit'));
const ResetPassword = lazy(() => import('../pages/passwords/resetPassword'));
const Dashboard = lazy(() => import('../pages/dashboard/dashboard'));
//const ChatContainer = lazy(() => import('../pages/chatContainer/chatContainer'));
const HooksTest = lazy(() => import('../components/hooksFormTest'));
const CustomHooksTest = lazy(() => import('../hooks/customHooksTest'));
const MyForm = lazy(() => import('../components/PhoneNumberBox/PhoneNumberBox'));
const AgGridTable = lazy(() => import('../components/AgTable/AgGridTable'));
// const PageNotFound = lazy(() => import('../pages/404/pageNotFound'));
const ProfilePage = lazy(() => import('../pages/profile/profilepage'));
const ChangePassword = lazy(() => import('../pages/profile/changePassword'));
const ProfileEdit = lazy(() => import('../pages/profile/profileEdits'));
const Faq = lazy(() => import('../cms/faq'));
const FAQIndex = lazy(() => import('../pages/faq'));
const ViewEmployee = lazy(() => import('../pages/employees/view'));
const ViewRole = lazy(() => import('../pages/roles/view'));
const MoviesIndex = lazy(() => import('../pages/movies/index'));
const MoviesCreate = lazy(() => import('../pages/movies/create'));
const MoviesEdit = lazy(() => import('../pages/movies/edit'));
const ViewMovies = lazy(() => import('../pages/movies/view'));
const NotificationsIndex = lazy(() => import('../pages/notifications/index'));
const ArtistIndex = lazy(() => import('../pages/artists/index'));
const ViewArtist = lazy(() => import('../pages/artists/viewArtist'));
const EditArtist = lazy(() => import('../pages/artists/editArtist'));
const AppUserIndex = lazy(() => import('../pages/appUsers/index'));
const ViewAppUser = lazy(() => import('../pages/appUsers/viewAppUser'));
const AppUserReports = lazy(() => import('../pages/appUsers/reports/index'));
const ReportsIndex = lazy(() => import('../pages/reports/index'));
const ViewReport = lazy(() => import('../pages/reports/viewReport'));
const ReportedMessagesIndex = lazy(() => import('../pages/reportedMessages/index'));
const VendorIndex = lazy(() => import('../pages/vendors/index'));
const ViewVendor = lazy(() => import('../pages/vendors/viewVendor'));
const ViewVendorProduct = lazy(() => import('../pages/vendors/viewVendorProduct'));
const EditVendor = lazy(() => import('../pages/vendors/editVendor'));
const AnthologiesIndex = lazy(() => import('../pages/anthologies/index'));
const ViewAnthology = lazy(() => import('../pages/anthologies/viewAnthology'));
const OrdersIndex = lazy(() => import('../pages/orders/index'));
const OrderStats = lazy(() => import('../pages/orders/stats'));
const ViewOrderLine = lazy(() => import('../pages/orders/viewOrderLine'));
const ViewOrder = lazy(() => import('../pages/orders/viewOrder'));
const PayoutsIndex = lazy(() => import('../pages/payouts/index'));
const ViewPayout = lazy(() => import('../pages/payouts/viewPayout'));
const WalletIndex = lazy(() => import('../pages/wallet/index'));
const StripeCallback = lazy(() => import('../pages/financialCenter/stripeCallback'));
const SubscriptionPlansIndex = lazy(() => import('../pages/subscriptionPlans/index'));
const CreateSubscriptionPlan = lazy(() => import('../pages/subscriptionPlans/createSubscriptionPlan'));
const EditSubscriptionPlan = lazy(() => import('../pages/subscriptionPlans/editSubscriptionPlan'));
const ViewSubscriptionPlan = lazy(() => import('../pages/subscriptionPlans/viewSubscriptionPlan'));
const SubscriptionsIndex = lazy(() => import('../pages/subscriptions/index'));
const ViewSubscription = lazy(() => import('../pages/subscriptions/viewSubscription'));
const CreateFAQ = lazy(() => import('../pages/faq/createFAQ'));
const EditFAQ = lazy(() => import('../pages/faq/editFAQ'));
const ViewFAQ = lazy(() => import('../pages/faq/viewFAQ'));
const CategoryIndex = lazy(() => import('../pages/faq/categories/index'));
const CreateCategory = lazy(() => import('../pages/faq/categories/createCategory'));
const EditCategory = lazy(() => import('../pages/faq/categories/editCategory'));
const FeedbackIndex = lazy(() => import('../pages/feedback/index'));
const ViewFeedback = lazy(() => import('../pages/feedback/viewFeedback'));
const EditFeedback = lazy(() => import('../pages/feedback/editFeedback'));
const BugSupportPage = lazy(() => import('../pages/support/bugs/index'));
const BugChatPage = lazy(() => import('../pages/bugChat/index'));
const AppUpdatesIndex = lazy(() => import('../pages/support/updates/index'));
const CreateAppUpdate = lazy(() => import('../pages/support/updates/createAppUpdate'));
const ViewAppUpdate = lazy(() => import('../pages/support/updates/viewAppUpdate'));

/** Redirect /appuser/edit/:userId to the view page since listeners have no editable admin fields */
function AppUserEditRedirect() {
  const { userId } = useParams();
  return <Navigate to={`/appuser/viewdetails/${userId}`} replace />;
}

export default function Routers() {
  return (
    <Router>
      <Routes>
        <Route element={<Outerlayout />}>
          <Route
            exact
            path="/"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{
                        left: '50%',
                        position: 'absolute',
                        textAlign: 'center',
                        top: '50%',
                        color: '#39979d',
                      }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  {' '}
                  <Login />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/login"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{
                        left: '50%',
                        position: 'absolute',
                        textAlign: 'center',
                        top: '50%',
                        color: '#39979d',
                      }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  {' '}
                  <Login />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/verify-email"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  {' '}
                  <UserVerification />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/register"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{
                        left: '50%',
                        position: 'absolute',
                        textAlign: 'center',
                        top: '50%',
                        color: '#39979d',
                      }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  <Register />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/forgetpassword"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{
                        left: '50%',
                        position: 'absolute',
                        textAlign: 'center',
                        top: '50%',
                        color: '#39979d',
                      }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  <Forgetpassword />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/reset/:id"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  {' '}
                  <ResetPassword />
                </UnProtectedRoute>
              </Suspense>
            }
          />
          {/* <Route exact path="/" element={<Dashboard />} /> */}
          <Route
            exact
            path="/reset"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <UnProtectedRoute>
                  {' '}
                  <ResetPassword />
                </UnProtectedRoute>
              </Suspense>
            }
          />
        </Route>
        <Route element={<Innerlayout />}>
          <Route
            exact
            path="/roles"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <RolesIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/chat"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/roles/create"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <CreateRoles />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/roles/edit/:roleId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <EditRoles />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/roles/viewdetails/:roleId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <ViewRole />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <Dashboard />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/employee"
            element={
              <Suspense
                fallback={
                  <div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}>
                    <SpinnerDotted />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <EmployeeIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/employee/create"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <EmployeeCreate />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            path="/employee/edit/:empId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <EmployeeEdit />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/employee/viewdetails/:empId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <ViewEmployee />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/notifications"
            element={
              <Suspense
                fallback={
                  <div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}>
                    <SpinnerDotted />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <NotificationsIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          {/* Artist Management */}
          <Route
            exact
            path="/artist"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ArtistIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/artist/viewdetails/:artistId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewArtist /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/artist/edit/:artistId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><EditArtist /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* App User (Listener) Management */}
          <Route
            exact
            path="/appuser"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><AppUserIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/appuser/viewdetails/:userId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewAppUser /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* Reports management */}
          <Route
            exact
            path="/report"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ReportsIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/report/viewdetails/:reportId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewReport /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/reported-messages"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ReportedMessagesIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* Redirect /appuser/edit/:userId → view page (no standalone edit form for listeners) */}
          <Route
            exact
            path="/appuser/edit/:userId"
            element={<AppUserEditRedirect />}
          />
          {/* Reports for a specific user */}
          <Route
            exact
            path="/appuser/reports/:userId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><AppUserReports /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* Report detail + moderation */}
          <Route
            exact
            path="/appuser/reports/viewdetails/:reportId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewReport /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* Vendor Management */}
          <Route
            exact
            path="/vendor"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><VendorIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/vendor/viewdetails/:vendorId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewVendor /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/vendor/viewdetails/:vendorId/products/:productId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewVendorProduct /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/vendor/edit/:vendorId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><EditVendor /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/order"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><OrdersIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/order/stats"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><OrderStats /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/order/lines/viewdetails/:orderLineId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewOrderLine /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/order/viewdetails/:orderId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewOrder /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/payout"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><PayoutsIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/payout/viewdetails/:vendorId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewPayout /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/wallet"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><WalletIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/financialcenter/stripe/return"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><StripeCallback /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/financialcenter/stripe/refresh"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><StripeCallback /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/financialcenter/callback"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><StripeCallback /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/subscriptionplans"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><SubscriptionPlansIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/subscriptionplans/create"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><CreateSubscriptionPlan /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/subscriptionplans/edit/:planId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><EditSubscriptionPlan /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/subscriptionplans/viewdetails/:planId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewSubscriptionPlan /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/subscriptions"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><SubscriptionsIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/subscriptions/viewdetails/:subscriptionId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewSubscription /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* FAQ Management */}
          <Route
            exact
            path="/faq"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><FAQIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/faq/create"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><CreateFAQ /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/faq/edit/:faqId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><EditFAQ /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/faq/viewdetails/:faqId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><ViewFAQ /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/faq/categories"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><CategoryIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/faq/categories/create"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><CreateCategory /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/faq/categories/edit/:categoryId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}
              >
                <ProtectedRoute><EditCategory /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* Support Management */}
          <Route
            exact
            path="/support/bugs"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><BugSupportPage /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/support/bugs/:feedbackId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><BugSupportPage /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* BugChat — new realtime chat module for bug communication */}
          <Route
            exact
            path="/support/bugchat"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><BugChatPage /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/support/updates"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><AppUpdatesIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/support/updates/create"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><CreateAppUpdate /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/support/updates/viewdetails/:appUpdateId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><ViewAppUpdate /></ProtectedRoute>
              </Suspense>
            }
          />
          {/* Feedback Management */}
          <Route
            exact
            path="/feedback"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><FeedbackIndex /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/feedback/viewdetails/:feedbackId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><ViewFeedback /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/feedback/edit/:feedbackId"
            element={
              <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}><SpinnerDotted /></div>}>
                <ProtectedRoute><EditFeedback /></ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/anthologies"
            element={
              <Suspense
                fallback={
                  <div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}>
                    <SpinnerDotted />
                  </div>
                }
              >
                <ProtectedRoute>
                  <AnthologiesIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/anthologies/viewdetails/:anthologyId"
            element={
              <Suspense
                fallback={
                  <div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}>
                    <SpinnerDotted />
                  </div>
                }
              >
                <ProtectedRoute>
                  <ViewAnthology />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/movies"
            element={
              <Suspense
                fallback={
                  <div style={{ textAlign: 'center', marginTop: '400px', color: '#39979d' }}>
                    <SpinnerDotted />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <MoviesIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/movies/create"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <MoviesCreate />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            path="/movies/edit/:userId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <MoviesEdit />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/movies/viewdetails/:userId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <ViewMovies />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/user/viewdetails/:userId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <ViewUsers />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/user/create"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <UserCreate />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/user/edit/:userId"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <UserEdit />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/hooks"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <HooksTest />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/customhooks"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <CustomHooksTest />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/text"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <MyForm />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/table"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <AgGridTable />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/user"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <UserIndex />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route
            exact
            path="/settings"
            element={
              <Suspense
                fallback={
                  <div>
                    <SpinnerDotted
                      style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                    />
                  </div>
                }
              >
                <ProtectedRoute>
                  {' '}
                  <Settings />
                </ProtectedRoute>
              </Suspense>
            }
          />
          <Route exact path="/preferences" element={<Navigate to="/settings" replace />} />
          <Route element={<ProfileLayout />}>
            <Route
              exact
              path="/profile"
              element={
                <Suspense
                  fallback={
                    <div>
                      <SpinnerDotted
                        style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                      />
                    </div>
                  }
                >
                  <ProtectedRoute>
                    {' '}
                    <ProfilePage />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/profile-edit"
              element={
                <Suspense
                  fallback={
                    <div>
                      <SpinnerDotted
                        style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                      />
                    </div>
                  }
                >
                  <ProtectedRoute>
                    {' '}
                    <ProfileEdit />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/cms"
              element={
                <Suspense
                  fallback={
                    <div>
                      <SpinnerDotted style={{ marginTop: '250px', marginLeft: '300px' }} />
                    </div>
                  }
                >
                  <ProtectedRoute>
                    {' '}
                    <Faq />
                  </ProtectedRoute>
                </Suspense>
              }
            />

            <Route
              exact
              path="/changePassword"
              element={
                <Suspense
                  fallback={
                    <div>
                      <SpinnerDotted
                        style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                      />
                    </div>
                  }
                >
                  <ProtectedRoute>
                    {' '}
                    <ChangePassword />
                  </ProtectedRoute>
                </Suspense>
              }
            />
          </Route>
        </Route>
        <Route
          exact
          path="*"
          element={
            <Suspense
              fallback={
                <div>
                  <SpinnerDotted
                    style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                  />
                </div>
              }
            >
              {' '}
              <PageNotFound />
            </Suspense>
          }
        />
        <Route
          exact
          path="/permission"
          element={
            <Suspense
              fallback={
                <div>
                  <SpinnerDotted
                    style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }}
                  />
                </div>
              }
            >
              <ProtectedRoute>
                {' '}
                <PermissionDenied />
              </ProtectedRoute>
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

// eslint-disable-next-line react/prop-types
function ProtectedRoute({ children }) {
  if (getCookies('Token')) {
    if (getCookies('USERPERMISSION')) {
      return children;
    }
    // Token exists but permissions are missing — broken session state, clear everything
    clearAuthCookies();
    sessionStorage.setItem('cookiesCleared', true);
    return <Navigate to="/login" />;
  }
  sessionStorage.setItem('cookiesCleared', true);
  return <Navigate to="/login" />;
}

// eslint-disable-next-line react/prop-types
function UnProtectedRoute({ children }) {
  // Only redirect to dashboard when the token is present AND not yet expired.
  // An expired token with no valid session should land on the login page.
  return isTokenValid() ? <Navigate to="/dashboard" /> : children;
}
